/**
 * serializeJsonLd
 * Serializes a JSON-LD payload for embedding in a <script> tag.
 *
 * Some payload values (citation titles, asset names, publisher names) are
 * authored outside this codebase, so a literal `</script>` in one of them would
 * close the tag early. Escaping `<` keeps the payload valid JSON while making
 * that impossible.
 */
export function serializeJsonLd(jsonLd: Record<string, unknown>): string {
    return JSON.stringify(jsonLd).replace(/</g, "\\u003c");
}
